module.exports = __webpack_public_path__ + "static/sm_img04@2x-d587f99d6f47e44968a11941b2f76176.jpg";